import LoanInfoIcon from "../assets/images/icons/loanInfo.gif";
import StatementIcon from "../assets/images/icons/payment.gif";
import CalculatorIcon from "../assets/images/icons/calculator.gif";
import FaqIcon from "../assets/images/icons/faq.gif";
import CalenderIcon from "../assets/images/icons/calendar.gif";
import ProductIcon from "../assets/images/icons/product.svg";
import LoanIcon from "../assets/images/icons/loanInfonew.gif";
import Profile from "../assets/images/icons/profile.gif";
import OtherIcon from "../assets/images/icons/otherIcon.gif";
const constVariable = {
  App_title: "Flexi Customer Portal",
};

const messages = {
  noPermission: {
    module: "You don't have access to",
    section: "You don't have access to make",
    action: "You don't have access to",
  },
  withdrErrorMessages: {
    overdue:
      "Please settle your overdue amount before raising a disbursement request.",
    commonError: "An error occurred",
    enterAmountError: "The entered amount is grater than available limit.",
    otpVerify:
      "Withdrawal Request is successfully captured. We will update you once request is processed",
  },
  paymentErrorMessages: {
    timeout: "Timeout waiting for API response",
    inProgress:
      "Final status of your transaction is awaited. Please check the latest status in transaction history.",
    partPayment:
      "Part Payment is not allowed if Principal Outstanding Amount is less than or equal to Rs.2",
    partPayment2: "The entered amount should be less than or equal to",
    overdue: "The entered amount is more than Over Due Amount",
  },
};

const filterOptionsWithdraw = [
  { label: "All", value: "all" },
  { label: "Pending", value: "pending" },
  { label: "Approved", value: "approve" },
  { label: "Rejected", value: "reject" },
];
const filterOptionsPay = [
  { label: "All", value: "all" },
  { label: "In progress", value: "inprogress" },
  { label: "Failed", value: "failed" },
  { label: "Success", value: "success" },
];
const filterOptionsPartPay = [
  { label: "All", value: "all" },
  { label: "Open", value: "Open" },
  { label: "Closed", value: "Closed" },
  { label: "Expired", value: "Expired" },
  { label: "Cancelled", value: "Cancelled" },
];
const filterOptionsDisbursement = [
  { label: "All", value: "all" },
  { label: "Approved", value: "approve" },
  { label: "Pending From Avanse", value: "AvanseApprovalPending" },
  { label: "Indraft", value: "indraft" },
  { label: "Rejected", value: "reject" },
  { label: "Query", value: "query" },
  { label: "Cancelled", value: "cancelled" },
];
const documentsItOptions = {
  certificate: [
    {
      label: "Get Provisional Interest Certificate",
      value: "provsonintstcert",
    },
    { label: "Get Interest Certificate", value: "instcert" },
  ],
  years: [
    { label: "FY22-23", value: "2022" },
    { label: "FY23-24", value: "2023" },
  ],
  payment_secret_key: "A745F72A4230A1CBF4D93EA702687567",
};
const maxFileSize = 10000000;
const paymentLimit = 900000;
const quickLinks = [
  { title: "Loan Account Info", icon: LoanIcon },
  { title: "Account Statements", icon: LoanInfoIcon },
  { title: "Amortization Schedule ", icon: Profile },
  { title: "Disbursement Request", icon: OtherIcon },
  { title: "Payment", icon: StatementIcon },
  { title: "FAQ", icon: FaqIcon },
];
const faqUrl = "https://www.avanse.com/faqs";
const applyNow = "https://www.avanse.com/apply-now?source=Header";
const iconsAndTitles = [
  { icon: ProductIcon, title: "Product 1" },
  { icon: ProductIcon, title: "Product 1" },
  { icon: ProductIcon, title: "Product 1" },
  { icon: ProductIcon, title: "Product 1" },
  { icon: ProductIcon, title: "Product 1" },
  { icon: ProductIcon, title: "Product 1" },
];
const disbReInfo = [
  {
    label:
      "Successfully raised disbursement requests will be processed within 72 hours.",
  },
  {
    label:
      "Once the disbursement requests are submitted, our team will conduct a thorough review.",
  },
  {
    label:
      "Incase of any discrepancies, the requests may be rejected, and you will be notified about the reason.",
  },
];
const paymentInfo = [
  {
    label:
      "You can make Part Payment & Overdue payments using the Payment section.",
  },
  {
    label:
      "Part payment is not allowed if there is an existing overdue against the LAN account.",
  },
  {
    label:
      "In each part payment request, the minimum principal amount allowed to be cleared is 3 times the EMI and its maximum value is 50% of the principal outstanding.",
  },
  {
    label:
      "Applicable charges will be levied for Part payment & Overdue payments as per the policy.",
  },
  {
    label:
      "For part payment requests, the Amortization chart is updated for the paid amount within 24 hours after the request is submitted.",
  },
];



const validStatuses = ["M", "C", "W", "E", "S"];

const withdrawInfo = [
  {
    label: "Successfully raised Withdrawal requests will be processed in 24 Hours",
  },
  {
    label:
      "Withdrawal request will be validated at Avanse end before taking it for processing. If there any concerns with respect to request, it will be rejected and reason will be informed to customer",
  },
  {
    label:
      "In case of Overdue, customer will have to clear it first and then only withdrawal request will be accepted",
  },
  {
    label:
      "OTP for withdrawal request will be received on registered mobile number of logged in customer",
  },
];

const flexiPaymentInfo = [
  {
    label:
      "Customer can make Part Payment and Overdue Payment from the Payment Section.",
  },
  {
    label:
      "Convience Fee will be applied to cover the cost of processing the transaction.",
  },
  {
    label:
      " If there is overdue on the account, customer needs to clear it first before going for Part Payment.",
  },
  {
    label:
      " Part Payment Fee will not be applied on the Part Payment.",
  },
  {
    label:
      "Payment for successful transactions will reflect in the account after 1 hour of transaction completion.",
  },
];

const currencyIcon = [
  {
    id: 3,
    currencyCode: "AED",
    currencyDescription: "Emirati Dirham",
    icon: "د.إ",
  },
  {
    id: 569,
    currencyCode: "AUD",
    currencyDescription: "Australian Dollar",
    icon: "$",
  },
  {
    id: 570,
    currencyCode: "BHD",
    currencyDescription: "Bahrain Dinar",
    icon: ".د.ب",
  },
  {
    id: 571,
    currencyCode: "CAD",
    currencyDescription: "Canadian Dollar",
    icon: "$",
  },
  {
    id: 572,
    currencyCode: "CHF",
    currencyDescription: "Swiss Franc",
    icon: "CHF",
  },
  {
    id: 573,
    currencyCode: "CNY",
    currencyDescription: "Chinese Yuan",
    icon: "¥",
  },
  {
    id: 574,
    currencyCode: "CZK",
    currencyDescription: "Czech Koruna",
    icon: "Kč",
  },
  {
    id: 575,
    currencyCode: "DKK",
    currencyDescription: "Danish Kroner",
    icon: "kr",
  },
  {
    id: 576,
    currencyCode: "EGP",
    currencyDescription: "Egyptian Pound",
    icon: "ج.م",
  },
  {
    id: 577,
    currencyCode: "EUR",
    currencyDescription: "Euro",
    icon: "€",
  },
  {
    id: 578,
    currencyCode: "GBP",
    currencyDescription: "Great Britain Pound",
    icon: "£",
  },
  {
    id: 579,
    currencyCode: "HKD",
    currencyDescription: "Hongkong Dollar",
    icon: "$",
  },
  {
    id: 580,
    currencyCode: "INR",
    currencyDescription: "Indian Rupee",
    icon: "₹",
  },
  {
    id: 581,
    currencyCode: "JOD",
    currencyDescription: "Jordan Dinar",
    icon: ".د.أ",
  },
  {
    id: 582,
    currencyCode: "JPY",
    currencyDescription: "Japanese Yen",
    icon: "¥",
  },
  {
    id: 583,
    currencyCode: "KWD",
    currencyDescription: "Kuwait Dinar",
    icon: ".د.ك",
  },
  {
    id: 584,
    currencyCode: "MYR",
    // Malaysian Ringgit icon is RM
    currencyDescription: "Malaysian Ringgit",
    icon: "RM",
  },
  {
    id: 585,
    currencyCode: "NOK",
    currencyDescription: "Norwegian Kroner",
    icon: "kr",
  },
  {
    id: 586,
    currencyCode: "NZD",
    currencyDescription: "New Zealand Dollar",
    icon: "$",
  },
  {
    id: 587,
    currencyCode: "OMR",
    currencyDescription: "Omani Rial",
    icon: "ر.ع.",
  },
  {
    id: 588,
    currencyCode: "PHP",
    currencyDescription: "Philippine Peso",
    icon: "₱",
  },
  {
    id: 589,
    currencyCode: "QAR",
    currencyDescription: "Qatar Rial",
    icon: "ر.ق.",
  },
  {
    id: 590,
    currencyCode: "RUB",
    currencyDescription: "Ruble",
    icon: "₽",
  },
  {
    id: 591,
    currencyCode: "SAR",
    currencyDescription: "Saudi Rial",
    icon: "ر.س.",
  },
  {
    id: 592,
    currencyCode: "SEK",
    currencyDescription: "Swedish Kroner",
    icon: "kr",
  },
  {
    id: 593,
    currencyCode: "SGD",
    currencyDescription: "Singapore Dollar",
    icon: "$",
  },
  {
    id: 594,
    currencyCode: "SYP",
    currencyDescription: "Syrian Pound",
    icon: "ل.س.",
  },
  {
    id: 595,
    currencyCode: "THB",
    currencyDescription: "Thai Baht",
    icon: "฿",
  },
  {
    id: 596,
    currencyCode: "TRY",
    currencyDescription: "Turkish Lira",
    icon: "₺",
  },
  {
    id: 597,
    currencyCode: "USD",
    currencyDescription: "US Dollar",
    icon: "$",
  },
  {
    id: 598,
    currencyCode: "ZAR",
    currencyDescription: "South African Rand",
    icon: "R",
  },
];

const paymentInstructions = [
  "Please ensure that the payment is made using all the generated payment links to complete the payment process for the entire amount.",
  " Multiple payment links are generated if the total payable amount exceeds ₹ 9 lakhs.",
  " The payment links will be activated in the same order as they appear on the customer portal. This will ensure that the total loan amount paid is aligned with the minimum allowed part payment amount, i.e., 3 times the EMI and the applicable charges.",
  " Each payment link will remain valid for 1 hour after being opened. If a payment fails, you are allowed up to 2 retry attempts.",
];
const overdueInstructions = [
  "Please ensure that the payment is made using all the generated payment links to complete the payment process for the entire amount.",
  "Multiple payment links are generated if the total payable amount exceeds ₹ 9 lakhs.",
  "Each payment link will remain valid for 1 hour after being opened. If a payment fails, you are allowed up to 2 retry attempts.",
];

const RelationWithStudentList = [
  "Spouse",
  "Sister in law",
  "Sister (married)",
  "Private Limited Entities",
  "Paternal Uncle",
  "Paternal uncle",
  "Paternal Grandmother",
  "Paternal Grandfather",
  "Paternal Aunt",
  "Partnership firm",
  "OTHERS",
  "Mother in Law",
  "Mother",
  "Maternal Uncle",
  "Maternal uncle",
  "Maternal or Paternal Uncle or Aunt",
  "Maternal Grandmother",
  "Maternal Grandfather",
  "Maternal aunt",
  "Maternal Aunt",
  "Limited Liability Partnership",
  "Grandparents",
  "Grandmother",
  "Grandfather",
  "First cousin",
  "father in law",
  "Father",
  "Brother in law",
  "BROTHER"
]

export default constVariable;
export const TrackingId = process.env.REACT_APP_GA_TRACKING_ID || "";
export {
  paymentInstructions,
  overdueInstructions,
  documentsItOptions,
  filterOptionsWithdraw,
  filterOptionsPay,
  messages,
  filterOptionsDisbursement,
  quickLinks,
  iconsAndTitles,
  faqUrl,
  applyNow,
  disbReInfo,
  paymentInfo,
  filterOptionsPartPay,
  validStatuses,
  currencyIcon,
  maxFileSize,
  paymentLimit,
  withdrawInfo,
  flexiPaymentInfo,
  RelationWithStudentList
};
